import { FileInfo } from "./lib";
import { UploadOutlined } from '@ant-design/icons';
import { Button, Upload } from 'antd';

interface UploadPanelProps {
  setFileInfo: (fileInfo: FileInfo) => void;
}

const UploadPanel = (props: UploadPanelProps) => {
  const { setFileInfo } = props;

  const beforeUpload = async (file: File): Promise<boolean> => {
    const reader = new FileReader();
    reader.onload = async (e) => {
      const { target: reader } = e;
      const text = reader?.result as string,
        name = file.name,
        fileInfo = { name, text };
      setFileInfo(fileInfo);
    };
    reader.readAsText(file);
    return false;
  };

  return <Upload
    accept={"application/har"}
    beforeUpload={beforeUpload}>
    <Button icon={<UploadOutlined />}>Click to Upload</Button>
  </Upload>;
};

export default UploadPanel;